import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

export const getBlogs = (setBlogData) => {
  axiosInstance
    .get(`/blog/published?page=1&limit=10`)
    .then((res) => {
      setBlogData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const viewSingleBlog = (id, setFormData) => {
  axiosInstance
    .get(`/blog/${id}`)
    .then((res) => {
      setFormData({
        id: res.data.data.id,
        blogTitle: res.data.data.blogTitle,
        body: res.data.data.body,
        categoryId: res.data.data.categoryId,
        tags: res.data.data.tags,
        featuredImage: res.data.data.featuredImage,
        status: res.data.data.status,
        created_by: res.data.data.created_by,
        createdAt: res.data.data.createdAt,
      });
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
